import { Observable } from 'rxjs';

import { DeliveryNoteOverviewRequest, DeliveryNoteOverviewResponse } from '../../model/delivery-notes.model';

export abstract class DeliveryNotesOverviewAdapter {
  abstract loadOverview(
    request: DeliveryNoteOverviewRequest
  ): Observable<DeliveryNoteOverviewResponse>;
}
